// ════════════════════════════════════════════════════════════
// Root route — ECR
// ════════════════════════════════════════════════════════════
// Layout est appliqué dans _authed.tsx (routes protégées),
// PAS ici. La route /login utilise son propre fullscreen.
// ════════════════════════════════════════════════════════════
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Toaster } from '@/components/ui/toast';
import { ConfirmProvider } from '@/components/ui/dialog';
import { CommandPalette, NotFound } from '@/components/shell';

// Devtools chargé seulement en dev (tree-shaké en prod)
const TanStackRouterDevtools = import.meta.env.PROD
  ? () => null
  : lazy(() =>
      import('@tanstack/react-router-devtools').then((m) => ({
        default: m.TanStackRouterDevtools,
      })),
    );

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFound,
});

function RootComponent() {
  return (
    <ConfirmProvider>
      <Outlet />
      <CommandPalette />
      <Toaster />
      <Suspense fallback={null}>
        <TanStackRouterDevtools position="bottom-right" />
      </Suspense>
    </ConfirmProvider>
  );
}
